/// <amd-module name="Artifacts/Connect/redux/Actions" />
import { ConnectToFeedData } from "Artifacts/Connect/redux/Contracts";
import { ToolId } from "Artifacts/Connect/types/ITool";
import { IFeed } from "Artifacts/Root/types/IFeed";
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

export const enum ConnectToFeedActionTypes {
  DismissFirstTimeMessage = "ConnectToFeed/FirstTimeMessage/Dismiss",
  InitializeConnectToFeedState = "ConnectToFeed/DataInitialized",
  LoadInitialData = "ConnectToFeed/LoadInitialData",
  LoadInitialDataStarted = "ConnectToFeed/LoadInitialDataStarted",
  LoadInitialDataFailed = "ConnectToFeed/LoadInitialDataFailed",
}

export const ConnectToFeedActions = {
  dismissFirstTimeMessage: (toolId: ToolId) =>
    trackedAction(createAction(ConnectToFeedActionTypes.DismissFirstTimeMessage, toolId)),
  initializeConnectToFeedState: (state: ConnectToFeedData) =>
    createAction(ConnectToFeedActionTypes.InitializeConnectToFeedState, state),
  loadInitialData: (feed: IFeed) => createAction(ConnectToFeedActionTypes.LoadInitialData, feed),
  loadInitialDataStarted: () => createAction(ConnectToFeedActionTypes.LoadInitialDataStarted),
  loadInitialDataFailed: (error: string) =>
    createAction(ConnectToFeedActionTypes.LoadInitialDataFailed, error),
};

export type ConnectToFeedActions = ActionsUnion<typeof ConnectToFeedActions>;
